import { z } from 'zod';

export const UserLinkedSearchSchema = z.object({ adv_id: z.string().default('') });
export type UserLinkedSearchSchemaType = z.infer<typeof UserLinkedSearchSchema>;
